import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <div className="flex items-center space-x-4 text-sm text-gray-500">
            <span>© 2025 Urban Forestry Platform</span>
            <span>•</span>
            <span>Hackensack, NJ</span>
          </div>
          
          <div className="flex items-center space-x-4 mt-2 sm:mt-0">
            <span className="text-xs text-gray-400">
              Powered by MapLibre GL JS
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
